import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { ReferData } from './refer.model';
import { CommonService } from '../services/common.service';
import { ToasterService } from '../services/toaster.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
// import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Component({
  selector: 'app-refer',
  templateUrl: './refer.component.html',
  styleUrls: ['./refer.component.css'],
  providers: [ToasterService,CommonService]
})
export class ReferComponent implements OnInit {
  referInfoSection = true;
  referFormSection: boolean;
  loading = false;
  cityList: any = [];
  noResult = false;
  refer: ReferData = new ReferData();
  states: any = []
  data: {};
  selectedProductValue: string;
  selectedOption: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  message: any;
  referBtn: boolean=true;
  referBtn2: boolean=true;
  userMobile:string = ''
  constructor(private router: Router, private serviceURLService: serviceURLService, public toasterService: ToasterService, public commonService : CommonService) { }

  ngOnInit() {
    this.userMobile = localStorage.getItem('mobileNumber');
    this.getCities();
    this.isReferMoreClick();
    this.CheckIfSecureNowUser();
    this. insurance();
  }

  CheckIfSecureNowUser(){
    this.loading=true
    var userId = localStorage.getItem("userID")
    this.serviceURLService.getPoliciesEcards(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      const insuranceDetails = successData.response.notifyPolicy;
      console.log(insuranceDetails)
      if(insuranceDetails.length>0){
        this.referBtn=false
         this.loading=false
      }
      else{
        this.referBtn=true
        this.loading=false
      }
      console.log( "isEcards "+ this.referBtn)
    }, errorData => {
       this.loading = false;
        this.router.navigate(['login']);
    })
  }



  insurance(){
    this.loading = true;
    var userId = localStorage.getItem("userID")   
    this.serviceURLService.getViewPolicies(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      if(successData.response.pamPolicy.length>0){
        this.referBtn2=false;
      }else{
        this.referBtn2=true;
      }   
      this.loading=false
      console.log( "isEB "+ this.referBtn2)
    })
  }
  
  isReferMoreClick(){
    var checkState = localStorage.getItem("backToPrevious");
    if(checkState){
      this.referInfoSection = false;
      this.referFormSection = true;
      setTimeout(() => {
        localStorage.removeItem("backToPrevious");
      }, 1000);
    }else{
      this.referInfoSection = true;
      this.referFormSection = false;
    }
  }

  //Call to create Prospect from Referral
  referFriend() {
    this.loading = true;
    this.refer.couponCode = localStorage.getItem('mobileNumber');
    this.serviceURLService.referFriend(this.refer).pipe(takeUntil(this.onDestroy$)).subscribe(
      success => {
        this.loading = false;
        this.router.navigate(['refer-success']);
      }, error => {
        this.loading = false;
      }
    )
  }
  selectedProduct(event){
    var product =  event.target.options[event.target.options.selectedIndex].text;
    this.selectedProductValue = product;
    console.log("product ",this.selectedProductValue);
    
  }
  //Call to save referral with new changes
  submitReferral() {
    this.loading = true;
    this.refer.couponCode = localStorage.getItem('mobileNumber');
    var userId = localStorage.getItem("userID")
    var byNumber = localStorage.getItem("mobileNumber")
    var byName = localStorage.getItem("name")
    this.data = {
      "name":this.refer.name,
      "email":this.refer.email,
      "mobile":this.refer.mobile,
      "productName":this.selectedProductValue,
      "ProductID":this.refer.product,
      "source":"Notify-Product",
      "city": this.refer.location,
      "referredBy":byNumber,
      "referredByName":byName
    }

    this.serviceURLService.saveReferral(userId,this.data).pipe(takeUntil(this.onDestroy$)).subscribe(
      success => {
        this.loading = false;
        this.router.navigate(['refer-success']);
      }, error => {
        this.loading = false;
        
       
        if(JSON.stringify(error.error.error) == "true"){
          this.toasterService.showErrorToaster("There is already an existing enquiry/policy of the person. Please try another email id.");
          console.log( "another number " + JSON.stringify(error.error.error));
        }

        if(JSON.stringify(error.error.error) == "false"){
          this.toasterService.showErrorToaster("There is already an existing enquiry/policy of the person. Please try another Mobile no.");
          console.log( "another number " + JSON.stringify(error.error.error));
        }
         

      }
    )
  }

  // Please try another mobile number.

  // Please try another email id

  getCities() {
    this.loading = true;
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
        (success: any) => {
        this.loading = false;
        this.cityList = success.data.cityList;
        }, error => {
        this.loading = false;
        }
    )
  }

  selectCity(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }
  checkCityValue(event): void {
    this.noResult = this.commonService.checkCityValue(event,this.cityList);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
